var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiConfigurationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.21875 7.49855C0.21875 3.77143 3.24018 0.75 6.9673 0.75C10.6944 0.75 13.7158 3.77143 13.7158 7.49855C13.7158 11.2257 10.6944 14.2471 6.9673 14.2471C3.24018 14.2471 0.21875 11.2257 0.21875 7.49855ZM6.96741 4C6.55319 4 6.21741 4.33579 6.21741 4.75V4.755C6.21741 5.16921 6.55319 5.505 6.96741 5.505H6.97241C7.38662 5.505 7.72241 5.16921 7.72241 4.755V4.75C7.72241 4.33579 7.38662 4 6.97241 4H6.96741ZM5.79671 7.33395C5.91448 7.56948 6.13945 7.71596 6.38291 7.74384L6.00352 9.26139C5.74453 10.2973 6.81994 11.16 7.77504 10.6825L7.77507 10.6824L7.80272 10.6686C8.1732 10.4834 8.32335 10.0329 8.1381 9.66238C8.02033 9.42686 7.79536 9.28038 7.55191 9.25251L7.93129 7.73496C8.19028 6.699 7.11488 5.83634 6.15977 6.31389L6.15977 6.31389L6.13212 6.32772C5.76163 6.51296 5.61147 6.96347 5.79671 7.33395Z",
    fill: "#257DE7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiConfigurationIcon);
export default __webpack_public_path__ + "static/media/api-configuration__icon.4d5e566e9c794d83d87250f8ab28ccce.svg";
export { ForwardRef as ReactComponent };